export default "/images/390f30689d557f183877a0c81043a724.avif";